import { memo, useEffect } from "react";
import PropTypes from "prop-types";
import Paragraphs from "app/pages/.shared/Paragraphs";
import "./FaqArticle.scss";
import { sendTagOnFaqArticlePage } from "app/utils/analytics";

const FaqArticle = ({ title, content = [] }) => {
	useEffect(() => {
		if (title) {
			sendTagOnFaqArticlePage(title);
		}
	}, [title]);

	return (
		<div className="faq-article">
			<div className="faq-article__title">{title}</div>
			<Paragraphs enableHTMLFormatting={true} paragraphs={content} />
		</div>
	);
};

FaqArticle.propTypes = {
	title: PropTypes.string,
	content: PropTypes.array,
};

export default memo(FaqArticle);
